export default __webpack_public_path__ + "static/media/lc-img.9bdf0aeb.webp";